import { Clock3, Mail, MapPin, Phone } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";

const cards = [
  {
    icon: MapPin,
    label: "Sede delle lezioni",
    value: "Via Mazzali 5, Milano",
    sub: "ANAS Milano Formazione",
    href: "https://www.google.com/maps/search/?api=1&query=Via+Mazzali+5+Milano",
    testid: "contatti-address",
  },
  {
    icon: Phone,
    label: "Telefono",
    value: "+39 351 393 7976",
    sub: "Chiamata o WhatsApp",
    href: "tel:+393513937976",
    testid: "contatti-phone",
  },
  {
    icon: Mail,
    label: "Email",
    value: "formazione@anasmilano.com",
    sub: "Risposta entro 24 ore lavorative",
    href: "mailto:formazione@anasmilano.com",
    testid: "contatti-email",
  },
];

export default function Contatti() {
  return (
    <section id="contatti" className="border-t border-line bg-paper py-16 md:py-24" data-testid="contatti-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHeading
          eyebrow="Dove siamo"
          title="Sede ANAS Milano e contatti diretti"
          sub="Vieni a trovarci in sede, chiamaci o scrivici: siamo a disposizione per ogni domanda sul corso e sull'iscrizione."
          testid="contatti"
        />
        <div className="mt-12 grid grid-cols-1 gap-6 md:grid-cols-3">
          {cards.map((c, i) => (
            <Reveal key={c.label} delay={i * 0.1}>
              <a
                href={c.href}
                target={c.href.startsWith("http") ? "_blank" : undefined}
                rel={c.href.startsWith("http") ? "noopener noreferrer" : undefined}
                className="group flex h-full flex-col border border-line bg-white p-7 transition-all duration-300 hover:-translate-y-1 hover:border-navy hover:shadow-xl"
                data-testid={c.testid}
              >
                <div className="flex h-11 w-11 items-center justify-center bg-navy text-white transition-colors group-hover:bg-brand-amber">
                  <c.icon className="h-5 w-5" />
                </div>
                <p className="mt-5 font-mono text-[11px] uppercase tracking-[0.2em] text-slate-500">{c.label}</p>
                <p className="mt-2 break-words font-heading text-lg font-bold tracking-tight text-navy">{c.value}</p>
                <p className="mt-1 text-sm text-slate-500">{c.sub}</p>
              </a>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.2}>
          <div className="mt-6 flex items-center gap-3 border border-line bg-white p-5 text-sm text-slate-600" data-testid="contatti-hours">
            <Clock3 className="h-4 w-4 shrink-0 text-brand-amber" />
            Segreteria aperta dal lunedì al venerdì, 9:00 – 18:00. Lezioni del corso: 14:00 – 18:00.
          </div>
        </Reveal>
      </div>
    </section>
  );
}
